import { styled } from "@mui/material/styles";
import { Box, Typography, Backdrop, Grid2 } from "@mui/material";

export const RootBox = styled(Box)({
  display: "flex",
  flexDirection: "column",
});

export const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
  color: "#fff",
  zIndex: theme.zIndex.drawer + 1,
}));

export const ContentBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

export const SectionHeading = styled(Typography)(({ theme }) => ({
  fontFamily: "'Quicksand', sans-serif",
  fontWeight: "bold",
  fontSize: "18px",
  color: theme.palette.text.primary,
  marginTop: theme.spacing(3),
  [theme.breakpoints.down("md")]: {
    fontSize: theme.spacing(2),
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));

export const BodyText = styled(Typography)(({ theme }) => ({
  ...theme.body,
  marginTop: theme.spacing(1),
  [theme.breakpoints.down("md")]: {
    fontSize: theme.spacing(2),
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));

export const CardsGrid = styled(Grid2)(({ theme }) => ({
  marginTop: theme.spacing(4),
}));
